// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"spinner_loadingWrapper__395XO","loadingCircle":"spinner_loadingCircle__1c8sW","rotate-loader":"spinner_rotate-loader__2yG2e"};